import { render, staticRenderFns } from "./TrafficTab.vue?vue&type=template&id=1cd3f048&"
import script from "./TrafficTab.vue?vue&type=script&lang=js&"
export * from "./TrafficTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports